var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Drawer, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import { List, TextField, TextInput, useDelete, DatagridConfigurable } from "react-admin";
import { Dialog } from "@sequentech/ui-essentials";
import { ListActions } from "@/components/ListActions";
import { ActionsColumn } from "@/components/ActionButons";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { SettingselectionsTypesEdit } from "./SettingsElectionsTypesEdit";
import { SettingsElectionsTypesCreate } from "./SettingsElectionsTypesCreate";
import { ThreeStateDatagridHeader } from "@/components/ThreeStateDatagridHeader";
export var EmptyBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n"])));
var useActionPermissions = function () {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    var canWriteTenant = authContext.isAuthorized(true, tenantId, IPermissions.TENANT_WRITE);
    return {
        canWriteTenant: canWriteTenant,
    };
};
var OMIT_FIELDS = ["id", "ballot_eml"];
var Filters = [_jsx(TextInput, { label: "Name", source: "name" }, 0)];
export var SettingsElectionsTypes = function () {
    var t = useTranslation().t;
    var deleteOne = useDelete()[0];
    var canWriteTenant = useActionPermissions().canWriteTenant;
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var _b = React.useState(false), openDeleteModal = _b[0], setOpenDeleteModal = _b[1];
    var _c = React.useState(), deleteId = _c[0], setDeleteId = _c[1];
    var _d = React.useState(false), openDrawer = _d[0], setOpenDrawer = _d[1];
    var _e = React.useState(undefined), recordId = _e[0], setRecordId = _e[1];
    useEffect(function () {
        if (recordId) {
            setOpen(true);
        }
    }, [recordId]);
    var handleCloseCreateDrawer = function () {
        setRecordId(undefined);
        setOpenDrawer(false);
        setOpen(false);
    };
    var handleOpenCreateDrawer = function () {
        setRecordId(undefined);
        setOpenDrawer(true);
        setOpen(false);
    };
    var handleCloseEditDrawer = function () {
        setOpen(false);
        setTimeout(function () {
            setRecordId(undefined);
        }, 400);
    };
    var editAction = function (id) {
        setRecordId(id);
    };
    var deleteAction = function (id) {
        setOpenDeleteModal(true);
        setDeleteId(id);
    };
    var confirmDeleteAction = function () {
        deleteOne("sequent_backend_election_type", { id: deleteId });
        setDeleteId(undefined);
    };
    var actions = [
        { icon: _jsx(EditIcon, {}), action: editAction },
        { icon: _jsx(DeleteIcon, {}), action: deleteAction },
    ];
    var CreateButton = function () { return (_jsx(Button, { onClick: handleOpenCreateDrawer, startIcon: _jsx(AddIcon, { sx: { fontSize: "24px" } }), children: t("electionTypeScreen.common.createNew") })); };
    var Empty = function () { return (_jsxs(EmptyBox, { m: 1, children: [_jsx(Typography, { variant: "h4", paragraph: true, children: t("electionTypeScreen.common.emptyHeader") }), canWriteTenant ? (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body1", paragraph: true, children: t("electionTypeScreen.common.emptyBody") }), _jsx(CreateButton, {})] })) : null] })); };
    if (!canWriteTenant) {
        return _jsx(Empty, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(List, { filters: Filters, actions: _jsx(ListActions, { custom: true, withFilter: true, withAction: canWriteTenant, doAction: handleOpenCreateDrawer, actionLabel: "common.label.add" }), empty: _jsx(Empty, {}), children: _jsxs(DatagridConfigurable, { header: ThreeStateDatagridHeader, omit: OMIT_FIELDS, children: [_jsx(TextField, { source: "id" }), _jsx(TextField, { source: "name" }), _jsx(ActionsColumn, { actions: actions })] }) }), _jsx(Drawer, { anchor: "right", open: openDrawer, onClose: handleCloseCreateDrawer, PaperProps: {
                    sx: { width: "40%" },
                }, children: _jsx(SettingsElectionsTypesCreate, { close: handleCloseCreateDrawer }) }), _jsx(Drawer, { anchor: "right", open: open, onClose: handleCloseEditDrawer, PaperProps: {
                    sx: { width: "40%" },
                }, children: _jsx(SettingselectionsTypesEdit, { id: recordId, close: handleCloseEditDrawer }) }), _jsx(Dialog, { variant: "warning", open: openDeleteModal, ok: String(t("common.label.delete")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                    if (result) {
                        confirmDeleteAction();
                    }
                    setOpenDeleteModal(false);
                }, children: t("common.message.delete") })] }));
};
var templateObject_1;
